export default __webpack_public_path__ + "static/media/ComunicadoLicEnfermedad.ef8d6e5f.jpeg";